import {google, outlook, office365, yahoo, ics, CalendarEvent} from "calendar-link";
import {
    WEDDING_DATE_END,
    WEDDING_DATE_START,
    WEDDING_DESCRIPTION,
    WEDDING_LOCATION,
    WEDDING_TITLE,
    WEDDING_VENUE
} from "../constants/wedding";

const calendarEvent: CalendarEvent = {
    title: WEDDING_TITLE,
    description: WEDDING_DESCRIPTION,
    location: WEDDING_VENUE + " " + WEDDING_LOCATION,
    start: WEDDING_DATE_START,
    end: WEDDING_DATE_END,
};

export const googleCalendarLink = google(calendarEvent);
export const outlookCalendarLink = outlook(calendarEvent);
export const office365CalendarLink = office365(calendarEvent);
export const yahooCalendarLink = yahoo(calendarEvent);
export const icsCalendarLink = ics(calendarEvent);
